// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"subscription_mobile_wrapper__snemc","title":"subscription_mobile_title__djIdo","table":"subscription_mobile_table__46Ef8"};